import { WorkflowNodeTypes } from './workflow-node-types.model';
import { WorkflowStateTypes } from './workflow-state-types.model';
import { WorkflowStates } from './workflow-states.model';

export class Workflows {
    ID?: number;
    NAME?: string;
    DESCRIPTION?: string;
    WORKFLOW_NODES?: any;
    WORKFLOW_STATES?: WorkflowStates;
    WORKFLOW_NODE_TYPES?: WorkflowNodeTypes;
    WORKFLOW_NODE_TYPES_ID?: number;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;

    WORKFLOW_STATE_TYPES?: WorkflowStateTypes;
}
